if (document.querySelector('search-page .search__button')) {
  document.querySelector('search-page .search__button').addEventListener('click', function (e) {
    e.preventDefault()
    const valueSearch = document.querySelector('search-page .input-search')
    window.location.replace('/search?q=' + valueSearch.value)
  })
}
